export default function MasonryServices() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Stucco Installation',
      description: 'Professional stucco application for new construction and renovations, including traditional three-coat and modern synthetic systems.'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Stone & Brick Masonry',
      description: 'Expert installation of natural stone, manufactured stone, and brick for walls, facades, fireplaces, and outdoor features.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Stucco Repair',
      description: 'Comprehensive repair services for cracks, water damage, and deterioration with color-matched finishes and texture restoration.'
    },
    {
      icon: 'ri-layout-masonry-line',
      title: 'Block & CMU Work',
      description: 'Concrete block and CMU construction for foundations, retaining walls, commercial buildings, and structural applications.'
    },
    {
      icon: 'ri-fire-line',
      title: 'Outdoor Living Spaces',
      description: 'Custom masonry for patios, outdoor kitchens, fire pits, pizza ovens, and entertainment areas with quality craftsmanship.'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Stucco Refinishing',
      description: 'Complete stucco refinishing including cleaning, repair, re-texturing, and painting to restore beauty and protection.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Masonry &amp; Stucco Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From installation to repair and restoration, our contractors provide complete masonry and stucco solutions for every project type.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-6 hover:shadow-lg transition-shadow border border-gray-200">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${service.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
